var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61131 1.13477C5.47744 -0.145554 2.86772 -0.354664 0.557204 0.569541C0.220672 0.704153 0 1.03009 0 1.39255V10.2755C0 10.8705 0.60096 11.2774 1.15342 11.0564C3.04549 10.2996 5.18259 10.4708 6.93001 11.5193L7.79498 12.0383C7.86094 12.0778 7.93151 12.0951 8 12.0939C8.06849 12.0951 8.13906 12.0778 8.20502 12.0383L9.06999 11.5193C10.8174 10.4708 12.9545 10.2996 14.8466 11.0564C15.399 11.2774 16 10.8705 16 10.2755V1.39255C16 1.03009 15.7793 0.704153 15.4428 0.569541C13.1323 -0.354664 10.5226 -0.145554 8.38869 1.13477L8 1.36798L7.61131 1.13477ZM8.57143 2.9551C8.57143 2.63951 8.31559 2.38367 8 2.38367C7.68441 2.38367 7.42857 2.63951 7.42857 2.9551V10.1932C7.42857 10.5088 7.68441 10.7646 8 10.7646C8.31559 10.7646 8.57143 10.5088 8.57143 10.1932V2.9551Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.933211 12.5111C2.4752 11.6116 4.38195 11.6116 5.92393 12.5111L6.75232 12.9943C7.52331 13.4441 8.47669 13.4441 9.24768 12.9943L10.0761 12.5111C11.6181 11.6116 13.5248 11.6116 15.0668 12.5111L15.1451 12.5568C15.4177 12.7158 15.5097 13.0657 15.3507 13.3383C15.1917 13.6109 14.8418 13.7029 14.5692 13.5439L14.4909 13.4983C13.3048 12.8063 11.8381 12.8063 10.6519 13.4983L9.82353 13.9815C8.6967 14.6388 7.3033 14.6388 6.17647 13.9815L5.34808 13.4983C4.16194 12.8063 2.69521 12.8063 1.50906 13.4983L1.43078 13.5439C1.15818 13.7029 0.808286 13.6109 0.649269 13.3383C0.490252 13.0657 0.58233 12.7158 0.854931 12.5568L0.933211 12.5111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/bookIcon.301c25c269df3a2161aaff43093891dd.svg";
export { ForwardRef as ReactComponent };